import { FirestoreDataConverter } from "firebase/firestore";
import { omitBy } from "lodash";
import Termo from "../models/termoAceite";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class TermoDb extends BaseDb<
  Termo,
  { termoId: string }
> {
  _path: string = "termos/termoId";
  getConverter(): FirestoreDataConverter<Termo> {
    return {
      fromFirestore: (snapshot) =>
        new Termo({
          ref: snapshot.ref.withConverter(this.getConverter()),
          titulo: snapshot.get("titulo"),
          slug: snapshot.get("slug"),
          obrigatorio: snapshot.get("obrigatorio") === true,
          ordem: snapshot.get("ordem") || 0,
          versaoVigente: snapshot.get("versaoVigente"),
        }),
      toFirestore: (termo: Termo) => toFirestore(omitBy(termo, ["ref"])),
    };
  }
}
